import { useTheme } from "@mui/system";
import newsGuardImg from "assets/images/newsguard.png";

export default function NewsGuardLogo({ fontSize }) {
  const { palette, shape } = useTheme();
  return (
    <img
      style={{
        height: fontSize,
        display: "block",
        backgroundColor: palette.common.white,
        borderRadius: shape.borderRadius / 2,
        padding: shape.borderRadius / 4,
      }}
      src={newsGuardImg}
      alt="NewsGuard Logo"
    />
  );
}
